import ContactForm from './ContactForm.vue'


export default {
  routers() {
    return [
      {
        path: '/oldcontact',
        name: 'oldcontact',
        component: ContactForm
      },
    ];
  }
}





// WEBPACK FOOTER //
// ./src/components/company/src/Router.js